import type { CarrierTrip } from "@/api/carrier";

type Progress = Pick<
  CarrierTrip,
  | "totalTasks"
  | "investigationTasks"
  | "pendingTasks"
  | "inProgressTasks"
  | "completedTasks"
  | "failedTasks"
  | "cancelledTasks"
>;

export function TripProgress({ progress }: { progress?: Progress }) {
  const counts = [
    ["pending", progress?.pendingTasks],
    ["in progress", progress?.inProgressTasks],
    ["completed", progress?.completedTasks],
    ["failed", progress?.failedTasks],
    ["cancelled", progress?.cancelledTasks],
  ] as const;
  return (
    <div>
      <span>
        {progress?.totalTasks === undefined
          ? "Task total unavailable"
          : `${progress.totalTasks} tasks`}
      </span>
      <span className="block text-xs text-muted-foreground">
        {counts.some(([, count]) => count === undefined)
          ? "Task progress unavailable"
          : counts.map(([label, count]) => `${count} ${label}`).join(" · ")}
      </span>
      {!!progress?.investigationTasks && (
        <p className="text-xs text-muted-foreground">
          {progress.investigationTasks} needs investigation · not completed or
          failed
        </p>
      )}
    </div>
  );
}
